import React, {useEffect, useContext} from 'react'
import { TitleContext, PathContext } from "../../../Context";
import { Link } from 'react-router-dom';
export const pageUrl = () => "/mysql/aggregate-functions/avg";

export default function AVG() {

    const title = useContext(TitleContext);
    const path = useContext(PathContext);
    useEffect(() => {
        title.setPageTitle("Mysql - Aggregate Functions - AVG() | Aspirant's Home");
        path.setPreviousNext({});
    }, [])

    return (
        <>
            <section class='clearfix mb-3'>
                <span className='float-start'>
                    <Link to='/mysql/aggregate-functions' onClick={() => path.setPathName('/mysql/aggregate-functions')} className='btn btn-primary'> <i class="fa-solid fa-less-than"></i>&nbsp; Back to Aggregate Functions </Link>
                </span>
            </section>
            <section className='mt-5 mb-5'>
                <h3>Mysql - AVG() Function</h3>
                <div className='mt-4 mb-5'>
                    <p>
                        The <strong>`AVG()`</strong> function in MySQL is used to calculate the average value of a numeric column. It helps in finding the mean value of data such as salaries, prices, or any other numeric data.
                    </p>
                    <h5>Syntax</h5>
                    <div className='codePalateBox mt-2 mb-2'>
                        <div className='codePalate' dangerouslySetInnerHTML={{
                            __html: `
                                <p><span class="color-blue">SELECT</span> AVG(column_name) <span class="color-blue">FROM</span> table_name;</p>
                            `
                        }}></div>
                    </div>
                    <p>
                        Let's consider a table <strong>`employees`</strong> with the following structure and data:
                    </p>
                    <table className='table' style={{border: '1px dashed #ccc'}}> 
                        <thead>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>id</th>
                                <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>name</th>
                                <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>department</th>
                                <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>salary</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <td style={{border: '1px dashed #ccc'}}>1</td>
                                <td style={{border: '1px dashed #ccc'}}>Jane Smith</td>
                                <td style={{border: '1px dashed #ccc'}}>IT</td>
                                <td style={{border: '1px dashed #ccc'}}>500000</td>
                            </tr>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <td style={{border: '1px dashed #ccc'}}>2</td>
                                <td style={{border: '1px dashed #ccc'}}>John Doe</td>
                                <td style={{border: '1px dashed #ccc'}}>IT</td>
                                <td style={{border: '1px dashed #ccc'}}>350000</td>
                            </tr>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <td style={{border: '1px dashed #ccc'}}>3</td>
                                <td style={{border: '1px dashed #ccc'}}>Johny Smith</td>
                                <td style={{border: '1px dashed #ccc'}}>Accounting</td>
                                <td style={{border: '1px dashed #ccc'}}>50000</td>
                            </tr>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <td style={{border: '1px dashed #ccc'}}>4</td>
                                <td style={{border: '1px dashed #ccc'}}>Jeffer Joe</td>
                                <td style={{border: '1px dashed #ccc'}}>HR</td>
                                <td style={{border: '1px dashed #ccc'}}>380000</td>
                            </tr>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <td style={{border: '1px dashed #ccc'}}>5</td>
                                <td style={{border: '1px dashed #ccc'}}>Sikhar Smith</td>
                                <td style={{border: '1px dashed #ccc'}}>Accounting</td>
                                <td style={{border: '1px dashed #ccc'}}>70000</td>
                            </tr>
                            <tr style={{border: '1px dashed #ccc'}}>
                                <td style={{border: '1px dashed #ccc'}}>6</td>
                                <td style={{border: '1px dashed #ccc'}}>Xavier Doe</td>
                                <td style={{border: '1px dashed #ccc'}}>IT</td>
                                <td style={{border: '1px dashed #ccc'}}>750000</td>
                            </tr>
                        </tbody>
                    </table>
                    <h5>Examples</h5>
                    <ul style={{listStyle: 'decimal'}}>
                        <li>
                            <strong>Calculating the Average Salary:</strong>
                            <p>
                                To calculate the average salary of all employees in the <strong>`employees`</strong> table:
                            </p>
                            <div className='codePalateBox mt-2 mb-2'>
                                <div className='codePalate' dangerouslySetInnerHTML={{
                                    __html: `
                                        <p><span class="color-blue">SELECT</span> AVG(salary) <span class="color-blue">AS</span> average_salary <span class="color-blue">FROM</span> employees;</p>
                                    `
                                }}></div>
                            </div>
                            <p>
                                This query will return:
                            </p>
                            <table className='table' style={{border: '1px dashed #ccc'}}> 
                                <thead>
                                    <tr style={{border: '1px dashed #ccc'}}>
                                        <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>average_salary</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{border: '1px dashed #ccc'}}>
                                        <td style={{border: '1px dashed #ccc'}}>350000</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                        <li>
                            <strong>Calculating the Average Salary by Department</strong>
                            <p>
                                To calculate the average salary for each department:
                            </p>
                            <div className='codePalateBox mt-2 mb-2'>
                                <div className='codePalate' dangerouslySetInnerHTML={{
                                    __html: `
                                        <p><span class="color-blue">SELECT</span> department, AVG(salary) <span class="color-blue">AS</span> average_salary</p>
                                        <p><span class="color-blue">FROM</span> employees</p>
                                        <p><span class="color-blue">GROUP BY</span> department;</p>
                                    `
                                }}></div>
                            </div>
                            <p>
                                This query will return:
                            </p>
                            <table className='table' style={{border: '1px dashed #ccc'}}> 
                                <thead>
                                    <tr style={{border: '1px dashed #ccc'}}>
                                        <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>department</th>
                                        <th style={{border: '1px dashed #ccc', backgroundColor:'#e1f1ff'}}>average_salary</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={{border: '1px dashed #ccc'}}>
                                        <td style={{border: '1px dashed #ccc'}}>IT</td>
                                        <td style={{border: '1px dashed #ccc'}}>533333.33</td>
                                    </tr>
                                    <tr style={{border: '1px dashed #ccc'}}>
                                        <td style={{border: '1px dashed #ccc'}}>Accounting</td>
                                        <td style={{border: '1px dashed #ccc'}}>60000</td>
                                    </tr>
                                    <tr style={{border: '1px dashed #ccc'}}>
                                        <td style={{border: '1px dashed #ccc'}}>HR</td>
                                        <td style={{border: '1px dashed #ccc'}}>380000</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    </ul>
                </div>
            </section>
        </>
    )
}